import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { jwtDecode } from "jwt-decode";
import { User as Auth0User } from "@auth0/auth0-react";
import { plainToInstance } from "class-transformer";

interface AuthenticationSliceState {
  accessToken: string | undefined
  authServerUserId: string | undefined
  authServerUser: object | undefined
}

const initialState: AuthenticationSliceState = {
  accessToken: undefined,
  authServerUserId: undefined,
  authServerUser: undefined
}

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setAccessToken(state, action: PayloadAction<string>) {
      const decoded = jwtDecode(action.payload);
      state.authServerUserId = decoded.sub;
      state.accessToken = action.payload;
    },
    setAuthServerUser(state, action: PayloadAction<object | undefined>) {
      state.authServerUser = action.payload;
    }
  }
})

// Export selectors
export const selectAccessToken = (state: RootState) => state.authentication.accessToken;
export const selectAuthServerUserId = (state: RootState) => state.authentication.authServerUserId;
export const selectAuthServerUser = createSelector([
  (state: RootState) => state.authentication.authServerUser
], (authServerUser) => {
  return plainToInstance(Auth0User, authServerUser)
});

// Export the auto-generated action creator with the same name
export const { setAccessToken, setAuthServerUser } = authenticationSlice.actions;

// Export the generated reducer function
export default authenticationSlice.reducer;
